import type { CSSProperties } from 'react';

import type { IconList } from '@snowit/icetypes';

import useStyle from '@snowit/system/useStyle';
import { Icon } from '@snowit/ui';

import cx from 'classnames';
import s from './Logo.module.scss';

type LogoProps = { className?: string; maxHeight?: number; name?: IconList };

const Logo = (props: LogoProps) => {
  const { logo } = useStyle();
  const { className, maxHeight = 2, name } = props;
  const hMax = { '--h-max': `${maxHeight}rem` } as CSSProperties;
  return (
    <div className={cx(s.wrapLogo, className)} style={hMax}>
      <Icon className={s.logo} name={name ?? logo} />
    </div>
  );
};

export default Logo;
